"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mui_1 = require("tss-react/mui");
const FlashOn_1 = __importDefault(require("@mui/icons-material/FlashOn"));
const CallSplit_1 = __importDefault(require("@mui/icons-material/CallSplit"));
const transactions_1 = require("companion-app-components/flux/transactions");
const QIconButton_1 = __importDefault(require("components/QIconButton"));
const utils_1 = require("data/transactions/utils");
const searchFilter_1 = require("data/transactions/searchFilter");
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const SplitField = ({ attributes, forceStatic, callbacks, editable, SHOW_ALL, fieldActive, txn, payeeCategoryMap, suggestCategoryForUncategorized, focusField, }) => {
    var _a;
    const { classes } = useStyles();
    let suggestTxn = null;
    if ((0, utils_1.isUncategorizedTxn)(txn) && suggestCategoryForUncategorized) {
        const suggestRecord = txn.payee && payeeCategoryMap ? payeeCategoryMap.get((_a = txn.payee) === null || _a === void 0 ? void 0 : _a.toLowerCase()) : null;
        if (suggestRecord && !transactions_1.transactionsUtils.isSplitTxn(suggestRecord.txn) && !(0, utils_1.isUncategorizedTxn)(suggestRecord.txn)) {
            suggestTxn = suggestRecord.txn;
        }
    }
    return (<styles_1.RegListItem {...attributes} tabIndex={null} className={classes.iconColumn} onClick={null}>
      {SHOW_ALL && !forceStatic &&
            <>
        {(transactions_1.transactionsUtils.isSplitTxn(txn) || editable) &&
                    <QIconButton_1.default aria-label="Split Transaction" autoFocus={fieldActive} ref={fieldActive ? (input) => {
                            focusField.current = input; // eslint-disable-line
                        } : null} focusRipple IconComponent={CallSplit_1.default} onClick={() => { var _a; return (_a = callbacks.regFieldClick) === null || _a === void 0 ? void 0 : _a.call(callbacks, 'split', txn); }} size="small-target" TooltipProps={{ enterDelay: 10 }}/>}

        {!editable && suggestTxn &&
                    <QIconButton_1.default aria-label="Fast Categorize" autoFocus={fieldActive} disabled={forceStatic} focusRipple ref={fieldActive ? (input) => {
                            focusField.current = input; // eslint-disable-line
                        } : null} IconComponent={FlashOn_1.default} onClick={(!txn.split && forceStatic) ? null : () => { var _a; return (_a = callbacks.regFieldClick) === null || _a === void 0 ? void 0 : _a.call(callbacks, 'categorySuggest', txn, suggestTxn); }} size="small-target" tooltip={`Click to fast categorize as ${(0, searchFilter_1.getFieldString)('category', suggestTxn)}`} TooltipProps={{ enterDelay: 10 }}/>}
      </>}
    </styles_1.RegListItem>);
};
exports.default = SplitField;
